import { z } from "zod";
import { create } from "zustand";

const editServiceSchema = z.object({
  id: z.string(),
  serviceName: z.string(),
  serviceQuantity: z.number(),
  price: z.number(),
});

type EditServiceType = z.infer<typeof editServiceSchema>;

interface SelectedService {
  selectedService: EditServiceType | null;
  setSelectedService: (selectedService: EditServiceType | null) => void;
}

interface selectedServiceName {
  selectedServiceName: string | undefined;
  setSelectedServiceName: (selectedServiceName: string | undefined) => void;
}

interface tempSelectedServiceName {
  tempSelectedServiceName: string | undefined;
  setTempSelectedServiceName: (
    tempSelectedServiceName: string | undefined,
  ) => void;
}

interface addService {
  isAddServiceOpen: boolean;
  setIsAddServiceOpen: (isAddServiceOpen: boolean) => void;
}

export const useAddServiceState = create<addService>()((set) => ({
  isAddServiceOpen: false,
  setIsAddServiceOpen: (isAddServiceOpen) => set({ isAddServiceOpen }),
}));

export const useTempSelectedServiceName = create<tempSelectedServiceName>()(
  (set) => ({
    tempSelectedServiceName: undefined,
    setTempSelectedServiceName: (tempSelectedServiceName) =>
      set({ tempSelectedServiceName }),
  }),
);

export const useSelectedServiceName = create<selectedServiceName>()((set) => ({
  selectedServiceName: undefined,
  setSelectedServiceName: (selectedServiceName) => set({ selectedServiceName }),
}));

export const useSelectedServiceState = create<SelectedService>()((set) => ({
  selectedService: null,
  setSelectedService: (selectedService) => set({ selectedService }),
}));
